export const COMPETITIONS_PATH = '/social/competitions';

export function competitionPath(id: string): string {
  return `${COMPETITIONS_PATH}/${encodeURIComponent(id)}`;
}
